import { render, staticRenderFns } from "./ECommerceAdd.vue?vue&type=template&id=4733970f&scoped=true&"
import script from "./ECommerceAdd.vue?vue&type=script&lang=js&"
export * from "./ECommerceAdd.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceAdd.vue?vue&type=style&index=0&id=4733970f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733970f",
  null
  
)

export default component.exports